<div class="row search-results">
    <div class="col-12">
        <app-book-detail-item [bookDetail]="bookDetail"></app-book-detail-item>
    </div>
    <!-- <div class="col-4">
      <app-navbar-youtube></app-navbar-youtube>
    </div> -->
  </div>